import React, { Component } from 'react';
import './styles.css';

export default class Appointments extends Component {
  render() {
    return (
      <div className="dashboard">
        <h1>Appointments Page</h1>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Appointments/Appointments.js